import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
import { getUserAndEventTime } from './lib/index.js';
export const createPiiDataDeletedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.PII_DATA_DELETED,
        ...getUserAndEventTime(),
        data: {
            taskId: "607721d4283e411c6e756501"
        }
    };
};
//# sourceMappingURL=pii-data-deleted.js.map